import script from "./searchSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchSort.vue?vue&type=script&setup=true&lang=ts"

import "./searchSort.vue?vue&type=style&index=0&id=3baccf26&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baccf26"]])

export default __exports__